module.exports = __webpack_public_path__ + "static/media/add.c07a99a8.svg";